import React, { type FC, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import {
  Panel,
  Title,
  Text,
  SpacingVertical,
  Checkbox,
  Flex,
  HelpIcon,
  MessageBox,
  TruncateAndTooltip,
} from "mailup-web-components";
import TablePreview from "./TablePreview";
import RedingSettings from "./RedingSettings";
import { useRecoilCallback, useRecoilValue, useSetRecoilState } from "recoil";
import { importFileWizardState } from "Pages/ImportWizard/recoil/state/state";
import { previewTableState } from "Pages/ImportWizard/recoil/state/stateStep2";
import { gainsightTrack } from "mailup-react-helpers";

const Preview: FC = () => {
  const intl = useIntl();

  const { FileName, IgnoreFirstRow, FileExt } = useRecoilValue(
    importFileWizardState,
  );
  const setImportFileWizardState = useSetRecoilState(importFileWizardState);
  const { ShowXlsWarning } = useRecoilValue(previewTableState);

  useEffect(() => {
    gainsightTrack("mup_importWizard_visitSecondStep", {});

    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const onChangeIgnoreFirstRow = () => {
    gainsightTrack("mup_importWizard_clickUseFirstRowAsHeader", {});

    setImportFileWizardState((prev) => ({
      ...prev,
      IgnoreFirstRow: !prev.IgnoreFirstRow,
    }));
  };

  return (
    <Panel>
      {ShowXlsWarning && (
        <>
          <MessageBox variant="warning">
            {intl.formatMessage(
              {
                id: "Load.FileImport.PreviewXlsWarning",
              },
              {
                fileName: FileName,
              },
            )}
          </MessageBox>
          <SpacingVertical />
        </>
      )}
      <Title variant="M">
        <TruncateAndTooltip
          text={intl.formatMessage(
            { id: "Load.FileImport.PreviewTitle" },
            { fileName: FileName },
          )}
        />
      </Title>
      <SpacingVertical variant="8" />
      <Text>{intl.formatMessage({ id: "Load.FileImport.PreviewDecr" })}</Text>
      <SpacingVertical />
      <Flex alignItems="center">
        <Checkbox
          onChange={onChangeIgnoreFirstRow}
          label={intl.formatMessage({ id: "Load.FileImport.IgnoreFirtsLine" })}
          checked={IgnoreFirstRow}
        />
        <HelpIcon
          data-tip={intl.formatMessage({
            id: "Load.FileImport.IgnoreFirtsLineTooltip",
          })}
        />
      </Flex>
      <SpacingVertical variant="8" />
      <TablePreview />
      <SpacingVertical />
      {[".csv", ".txt"].includes(FileExt?.toLowerCase()) && <RedingSettings />}
    </Panel>
  );
};
export default Preview;
